import React from 'react';
import { useTranslation } from "react-i18next";
import { Input, NumericTextBox } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FloatingLabel } from '@progress/kendo-react-labels';
import { Button } from '@progress/kendo-react-buttons';
export default function SilosDetailsComponents() {

    const { t } = useTranslation();

    const [integrador, setIntegrador] = React.useState('');

    const Integradores = [
        'Baseball',
        'Basketball',
        'Volleyball'
    ];
    return (
        <div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_Silo")}</h5>
                        </div>

                        <div className="container p-3 p-md-4 d-flex justify-content-center">
                            <div className="row g-4 mb-4">
                                {/* Primera columna con 3 elementos */}
                                <div className="col-12 col-md-6">
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <Input
                                                label={t("Global_Label_Text_Description")}
                                                style={{ width: "70%" }}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <NumericTextBox
                                                label={t("Global_Label_Text_Capacity")}
                                                style={{ width: "100%" }}
                                                defaultValue={0}
                                                min={0}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <FloatingLabel label={t("Global_Label_Text_Sensor")} editorId="ciudadIntegrador" editorValue={integrador}>
                                                <DropDownList
                                                    id="ciudadIntegrador"
                                                    style={{ width: "100%" }}
                                                    data={Integradores}
                                                    value={integrador}
                                                    onChange={(e) => setIntegrador(e.target.value)}
                                                />
                                            </FloatingLabel>
                                        </div>
                                    </div>
                                </div>

                                {/* Segunda columna con 2 elementos */}
                                <div className="col-12 col-md-6">
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <NumericTextBox
                                                label={t("Global_Label_Text_Maximum_Quantity")}
                                                style={{ width: "100%" }}
                                                defaultValue={0}
                                                min={0}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <NumericTextBox
                                                label={t("Global_Label_Text_Minimum_Quantity")}
                                                style={{ width: "100%" }}
                                                defaultValue={0}
                                                min={0}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>




            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="d-flex justify-content-end mb-3">
                        <Button className="action-button me-lg-11">{t("Global_Label_Text_Save")}</Button>
                    </div>
                </div>
            </div>

        </div>
    );
}